import { useContext } from "react";
import {
  findEmpresasV2,
  updateEmpresasV2,
} from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import { notify } from "../../../../utils/notify";
import TabGuias from "../children/tabsclientes/TabGuias";
import { ClientesBodyContext } from "../contexts/ClientesBodyContext";

const useClientesBodyController = (setLoading, setOpen) => {
  const {
    // tab guias
    deliveryAddress,
    setDeliveryAddress,
    contacts,
    setContacts,
    authorized,
    setAuthorized,
    commercialInfos,
    setCommercialInfos,
    financialInfos,
    setFinancialInfos,
    othersInfos,
    setOthersInfos,

    queryParams,
    setQueryParams,
  } = useContext(ClientesBodyContext);

  const switches = [
    {
      label: "Endereços Cobrança/Entrega",
      value: deliveryAddress,
      setValue: setDeliveryAddress,
    },
    {
      label: "Contatos",
      value: contacts,
      setValue: setContacts,
    },
    {
      label: "Autorizados",
      value: authorized,
      setValue: setAuthorized,
    },
    {
      label: "Informações Comerciais",
      value: commercialInfos,
      setValue: setCommercialInfos,
    },
    {
      label: "Informações Financeiras",
      value: financialInfos,
      setValue: setFinancialInfos,
    },
    {
      label: "Outras Informações",
      value: othersInfos,
      setValue: setOthersInfos,
    },
  ];

  const tabTitles = [{ label: "Guias" }];

  const tabContents = [<TabGuias key="tab-guias-clientes" />];

  const handleSaveClientParams = async () => {
    setLoading(true);
    const clientParamsBody = {
      guia_clientes_autorizados: authorized ? 1 : 0,
      guia_clientes_contatos: contacts ? 1 : 0,
      guia_clientes_enderecos: deliveryAddress ? 1 : 0,
      guia_clientes_infoscomerciais: commercialInfos ? 1 : 0,
      guia_clientes_infosfinanceiras: financialInfos ? 1 : 0,
      guia_clientes_outrasinfos: othersInfos ? 1 : 0,
    };

    try {
      let companyIds = [],
        successful = 0,
        getAllCompanyIds = await findEmpresasV2(queryParams.empresa_cnpj);

      if (getAllCompanyIds.success)
        companyIds = getAllCompanyIds.data.map((e) => e.id);
      else
        throw new Error(
          "Ocorreu um erro ao buscar as empresas no sistema. Tente novamente."
        );

      for (const id of companyIds) {
        const updateClientParams = await updateEmpresasV2({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: id,
          body: clientParamsBody,
        });

        if (updateClientParams.success) successful++;
      }

      if (successful === companyIds.length) {
        Object.keys(clientParamsBody).forEach((key) => {
          if (clientParamsBody[key] || clientParamsBody[key] === 0) {
            sessionStorage.setItem(key, clientParamsBody[key].toString());
            clientParamsBody[key] = clientParamsBody[key].toString();
          } else {
            sessionStorage.setItem(key, "");
            clientParamsBody[key] = "";
          }
        });

        setQueryParams((current) => ({ ...current, ...clientParamsBody }));
        setOpen(false);
        return notify("Parâmetros atualizados com sucesso!", true, "success");
      } else
        throw new Error(
          "Não conseguimos atualizar os parâmetros de todas as empresas. Tente novamente."
        );
    } catch (e) {
      notify(e, false, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    tabTitles,
    tabContents,
    switches,
    handleSaveClientParams,
  };
};

export default useClientesBodyController;
